import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useMediaQuery, useTheme } from '@mui/material';


const ShippingTypeList = () => {
    const theme = useTheme();
     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.shippingTypes}`;

    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [gridApi, setGridApi] = useState(null);
    const [error, setError] = useState("")
    const gridRef = useRef();
    const navigate = useNavigate();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'code', enableRowGroup: true },
        { field: 'shippingMethodName', headerName: 'Shipping Type', enableRowGroup: true },
    ]);

    const findShippingTypes = async () => {
        try {
            const list = await OAuthService.getList(url + `?sort=code,asc&size=1000`);
            const shippingTypes = list.data?._embedded?.shippingTypes
            setRowData(shippingTypes);
        } catch (error) {
            console.log('error', error)
            setError(error.message);
        }
    }

    const onGridReady = useCallback((params) => {
        findShippingTypes();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    
    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'ShippingType.xlsx',
            sheetName: 'Shipping Type'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            // var filename = row?._links?.user?.href.split('/').pop()
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findShippingTypes();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

  
     const goToRoleEdit = useCallback(
          (data) => {
            if (data?.id !== undefined) {
              navigate("/editShippingType/" + data.id);
            }
          },
          [navigate],
        );
        const onRowDoubleClicked = (params) => {
          if (isMobile) return;
          goToRoleEdit(params?.data);
        };
    
        const onRowClicked = (params) => {
          if (!isMobile) return;
          goToRoleEdit(params?.data);
        };

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Container Type"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addShippingType"
                pageName="Shipping Type List"
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                deleteDisable={deleteDisable}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={10}
                    cacheBlockSize={10}
                    saveGridStateName={'shippingTypeList'}
                />
            </div>
        </>
    )
}

export default ShippingTypeList